import React, { useState, useEffect  } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import NewRoster from "./NewRoster";
import { Icons } from "../utility/icons";
import { variables } from "../utility/variables";
import { useMsal } from '@azure/msal-react';

const RosterHistory = () => {
  const { id } = useParams();
  const location = useLocation();
  const { agr } = location.state || {};  
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [tabNames, setTabNames] = useState([]);
  const [rateRosterList, setRateRosterList] = useState([]);
  const [currentTabId, setCurrentTabId] = useState('tab_RosterHistory');
  const [infoBanner, setInfoBanner] = useState(null);
  const [preventSubmitMsg, setPreventSubmitMsg] = useState(null);


  const tabList = [
    {
      tabName: 'Roster History',
      tabId: 'rosterTab_RosterHistory', 
      allowedRoleIds: [1, 2, 3],
    },
    {
      tabName: 'Submit New Roster',
      tabId: 'rosterTab_NewRoster', 
      allowedRoleIds: [1, 2],
    }
  ];

  useEffect(() => {
    initializeList();
    setCurrentTabId(tabList[0].tabId);
    // Duo Hong 3/14/25: Update warning banner condition to check usernames too and account for bad data (e.g. APM_Name = ' ')
    if (!agr.PA_DAR || !agr.PA_APM || !agr.PA_APM_Name || !agr.PA_DAR_Name || !agr.PA_DAR.trim() || !agr.PA_APM.trim() || !agr.PA_APM_Name.trim() || !agr.PA_DAR_Name.trim() ) {
      setInfoBanner('This Agreement/PO is missing an APM/DAR assignment. Please contact a PA Administrator before submitting.');
      setPreventSubmitMsg('You cannot submit a Roster for an Agreement/PO with a missing APM/DAR assignment');
    }
    else if (agr.LastRosterStatus === 'Submitted') {
      setPreventSubmitMsg('This Agreement/PO is already pending a submitted Roster');
    }
  }, []);

  const initializeList = async () => {
    const response = await fetch(variables.API_URL + `User/validateuser`, {
      method: "GET",
      mode: "cors",
      credentials: "include", // important to send/set cookies
    });
    if (response.status === 401) {
      // Handle unauthorized
      console.log('RosterHistory.js: Unauthorized or session expired: Redirect to login');
      alert('Unauthorized or session expired: Redirect to login');
      navigate('/signin');
    }
    const data = await response.json();
    if (data && data[0]) {
      console.log('User is authorized', data);
    } else {
      instance.logoutRedirect(); // Log out unauthorized users
    } 

    // Duo Hong 6/18/2025: Set tabs based on user role based on GlobalVendorID
    fetch(variables.API_URL + `User/getCurrentUserRoles`, {
      method: "GET",
      mode: "cors",
      credentials: "include", // important to send/set cookies
    })
      .then(response => response.json())
      .then(data => {
        let tabs = ["rosterTab_RosterHistory"];
        data = data.filter(r => r.globalVendorID === agr.GlobalVendorID && r.roleId === 1)
        if (data.length) {
          tabs.push("rosterTab_NewRoster");
        }
        setTabNames(tabs);
      })
    
    // step 4: fetch roster list using api call
    fetch(variables.API_URL + `Roster/GetRosterHistory?ManagementId=${id}`, {
      method: "GET",
      mode: "cors",
      credentials: "include", // important to send/set cookies
    })
      .then(response => response.json())
      .then(data => {
        console.log("GetRosterHistory: data ", data );
        setRateRosterList(data);
      });
    //setRateRosterList(dummyData);
  }

  const changeTab = (e) => {
    setCurrentTabId(e.target.id);
  };

  const handleDownloadRoster = async (e) => {
    e.preventDefault(); // Prevent default anchor behavior
    const dataContainerName = e.currentTarget.getAttribute('data-container-name');
    const dataFileName = e.currentTarget.getAttribute('data-file-name');
    const dataFileNameforDownload = e.currentTarget.getAttribute('data-file-name-display');

    try {
      // // step 1: if no active account, re-direct to sign in page
      // const userActiveAccount = await instance.getActiveAccount();
      // if(!userActiveAccount){
      //   navigate('/signin');
      // }
      // const userEmail = userActiveAccount.username;
      // // step 2: get access token
      // const tokenResponse = await instance.acquireTokenSilent({
      //   scopes: [`api://${process.env.REACT_APP_ROSTER_CLIENTID}/access_as_user`],
      //   account: userActiveAccount,
      // });
      // const accesstoken = tokenResponse.accessToken;
        const response = await fetch(variables.API_URL + `Roster/download/${dataContainerName}, ${dataFileName}, ${id}`, {
        method: "GET",
        mode: "cors",
        credentials: "include", // important to send/set cookies
    });

      if (!response.ok) {
        throw new Error("File download failed.");
      }

      // Convert the response to a Blob
      const blob = await response.blob();

      // Create a link element to trigger the download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Get the filename from the content-disposition header (if available)
      const contentDisposition = response.headers.get("content-disposition");
      let fileName = dataFileNameforDownload;

      // Set the filename and trigger the download
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      // Clean up by revoking the object URL
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  }

  return (
    <div className="mx-20 my-10 flex flex-col">
      { 
        infoBanner && 
        <span className="mb-5 p-3 w-1/2 border-2 rounded-md border-blue-800 bg-blue-100">
          {infoBanner}
        </span>
      }
      <div className='p-3 w-1/2 bg-slate-100 rounded'>
        <h4 className="text-xl mb-5">Roster History</h4>
        <div className='flex flex-col gap-2'>
            <div className='flex flex-row w-full align-middle'>
              <h6 className='w-1/3'>Agreement Number / PO</h6>
              <input id='RosterHistory_AgrNumber' name='AgrPO' className='w-2/3 p-2 border rounded-xl' type='text' value={agr.AgreementNumber + (agr.annualAgrNumber ? ', ' + agr.annualAgrNumber : '') + (agr.PONumber ? ' / ' + agr.PONumber : '')}/>
            </div>
            <div className='flex flex-row w-full align-middle'>
              <h6 className='w-1/3'>Agreement Title</h6>
              <input id='RosterHistory_AgrTitle' name='AgreementTitle' className='w-2/3 p-2 border rounded-xl' type='text' value={agr.AgreementTitle}/>
            </div>
            <div className='flex flex-row w-full align-middle'>
              <h6 className='w-1/3'>PA APM</h6>
              <input id='RosterHistory_PAAPM' name='PA_APM_Name' className='w-2/3 p-2 border rounded-xl' type='text' value={agr.PA_APM_Name}/>
            </div>
            <div className='flex flex-row w-full align-middle'>
              <h6 className='w-1/3'>PA DAR</h6>
              <input id='RosterHistory_PADAR' name='PA_DAR_Name' className='w-2/3 p-2 border rounded-xl' type='text' value={agr.PA_DAR_Name}/>
            </div>
            {
              agr.LastRosterStatus && 
              <div className='flex flex-row w-full align-middle'>
                <h6 className='w-1/3'>Latest Roster Status</h6>
                <input id='RosterHistory_LastRosterStatus' name='LastRosterStatus' className='w-2/3 p-2 border rounded-xl' type='text' value={agr.LastRosterStatus}/>
              </div>
            }
        </div>
      </div>
      <br />
      <br />
      <div className='flex flex-col justify-start w-full rounded'>
        <div className="font-medium text-center text-gray-500 border-gray-200 dark:text-gray-400 dark:border-gray-700">
          <ul className="flex flex-wrap -mb-px">
            {tabList.map(t => tabNames.includes(t.tabId) && (
              <li className="me-2 border rounded">
                <a 
                  onClick={e => changeTab(e)}
                  id={t.tabId}
                  className={
                    `inline-block p-4 border-b-2 border-transparent cursor-pointer rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 ${currentTabId === t.tabId ? 'text-blue-600 border-blue-600 active dark:text-blue-500 dark:border-blue-500' : ''}`
                  }
                >
                  {t.tabName}
                </a>
              </li>
            ))}
          </ul>
        </div>
        { 
          currentTabId === 'rosterTab_RosterHistory' &&
          <table id='AgreementsSearchResults' className='table table-auto border rounded p-5'>
            <thead className="border rounded p-5 text-left">
              <tr className='p-4 bg-blue-200'>
                <th className='p-4'>Submission #</th>
                <th className='p-4 hidden'>File Name</th>
                <th className='p-4'>Submitted by</th>
                <th className='p-4'>Submitted Date</th>
                <th className='p-4'>Review Status</th>
                <th className='p-4'># of Approved Rates</th>
                <th className='p-4'># of Denied Rates</th>
                <th className='p-4'>Final Decision Date</th>
                <th className='p-4'>Download</th>
              </tr>
            </thead>
            <tbody>
              {
                rateRosterList.map(item => {
                  const date_submitted = new Date(item.SubmittedDate);
                  const fDate_submitted = date_submitted.toLocaleString();
                  const date_finalized = item.FinalDecisionDate ? new Date(item.FinalDecisionDate) : '--';
                  const fDate_finalized = date_finalized.toLocaleString();
                  return (
                    <tr key={item.id} className="odd:bg-gray-100" >
                      <td className='p-4'>{item.SubmissionNumber}{item.VersionNo === null || item.VersionNo === 1 ?'': '.' + (item.VersionNo - 1)} </td>
                      <td className='p-4 hidden'>{item.FileName}</td>
                      <td className='p-4'>{item.SubmittedBy}</td>
                      <td className='p-4'>{fDate_submitted}</td>
                      <td className='p-4'>
                        <span className="inline">
                          {item.ReviewStatus ?? '--'}{item.ReviewStatus === 'Rejected' && Icons.InfoBtn({ className: "w-4 cursor-pointer" })}
                        </span>
                      </td>
                      <td className='p-4'>{(!item.ReviewStatus || ['Rejected', 'Submitted'].includes(item.ReviewStatus)) ? '--' : item.ApprovedRatesCount ?? 0 }</td>
                      <td className='p-4'>{(!item.ReviewStatus || ['Rejected', 'Submitted'].includes(item.ReviewStatus)) ? '--' : item.DeniedRatesCount ?? 0 }</td>
                      <td className='p-4'>{fDate_finalized}</td>
                      <td className='p-4 text-center'>
                        <div className="flex justify-center w-full" onClick={handleDownloadRoster} data-container-name={item.ContainerName} data-file-name={item.FileName}  data-file-name-display={item.FileNameDisplay}>{Icons.DownloadBtn({ className: "w-4 cursor-pointer" })}</div>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        }
        {
          currentTabId === 'rosterTab_NewRoster' &&
          (<NewRoster managementId={id} preventSubmit={preventSubmitMsg}/>)
        }
      </div>
    </div>

  )
}

export default RosterHistory;
